export const formatAddress = (address: string, breakpoint: string): string => {
  if (breakpoint === 'xs' || breakpoint === 's' || breakpoint === 'm')
    return `${address.substring(0, 8)}...${address.substring(address.length - 6, address.length)}`
  else if (breakpoint === 's')
    return `${address.substring(0, 10)}...${address.substring(address.length - 6, address.length)}`
  else if (breakpoint === 'm' || breakpoint === 'l')
    return `${address.substring(0, 12)}...${address.substring(address.length - 8, address.length)}`
  else return address
}
